import React, { useEffect, useState } from 'react';
import { IonRow, IonCol } from '@ionic/react';
import { ApplicationState } from '../store';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import useMopHooks from '../helpers/useMopHook';
import { simpleChannelType } from '../store/LocationStore';
import Button from './Button';

const MopFooterConfirmStore: React.FC = () => {
    let history = useHistory();
    const location = useLocation();
    const locationState = useSelector((state: ApplicationState) => state.location);
    const { onChannelSelected } = useMopHooks();
    const [showButton, setShowButton] = useState(true);

    useEffect(() => {
        setShowButton(location.pathname !== "/ordertype");
    }, [location.pathname]);

    const handleClick = () => {
        // Use selected store channel instead of having extra state for order type?
        if (location.pathname.includes('/storesearch')) {
            if (locationState?.selectedStore){
                // If selectedStore supports both eat in and takeaway, then orderType, else onEatInSelected();
                if (locationState?.selectedStore?.supportedChannels.length > 0) {
                    history.push('/ordertype');
                } else {
                    onChannelSelected(locationState.selectedStore.supportedChannels[0]);
                }
            }
        } else {
            history.push(`/categories`);
        }
    }

    return (
        <div className="MopFooterInner">
            <IonRow className="ion-align-items-center">
                <IonCol size="4">
                    <div className="FooterStoreWrapper">
                        <span className="CollectFrom">{location.pathname === "/storesearch" || location.pathname === "/ordertype" ? "Store" : locationState?.selectedChannel?.channelType === simpleChannelType.ClickAndCollect ? "Collect from" : "Eat in"}</span><br />
                        <span className="Location">{locationState?.selectedStore === undefined ? "Select a store" : locationState?.selectedStore.storeName}</span>
                        {locationState?.selectedStore?.takingMopOrders === false ? <span style={{ color: "#ff0" }}> - Order ahead not available</span>: null}
                    </div>
                </IonCol>
                { showButton &&
                    <IonCol size="8">
                        <Button
                            onClick={handleClick}
                            disabled={locationState?.selectedStore === undefined || locationState?.selectedStore.takingMopOrders === false}
                            expand="block"
                            color="secondary"
                            rounded
                        >
                            Confirm
                        </Button>
                    </IonCol>
                }
            </IonRow>
        </div>
    );
};

export default MopFooterConfirmStore;
